import axiosClient from "../axiosClient";
import { ref, inject } from "vue";
import { useRouter } from "vue-router";

export default function useCategories() {
  const categories = ref({});
  const category = ref({});
  const validationErrors = ref({});
  const isLoading = ref(false);

  const router = useRouter();
  const swal = inject("$swal");

  const getCategories = async (
    page = 1,
    search_id = "",
    search_name_en = "",
    search_name_ar = "",
    search_parent = "",
    search_global = "",
    order_column = "created_at",
    order_direction = "desc",
    per_page = 10
  ) => {
    axiosClient
      .get(
        "/categories?" +
          "page=" +
          page +
          "&search_id=" +
          search_id +
          "&search_name_en=" +
          search_name_en +
          "&search_name_ar=" +
          search_name_ar +
          "&search_parent=" +
          search_parent +
          "&search_global=" +
          search_global +
          "&order_column=" +
          order_column +
          "&order_direction=" +
          order_direction +
          "&per_page=" +
          per_page
      )
      .then((response) => {
        categories.value = response.data;
      })
      .catch((error) => {
        if (error.response?.data) {
          validationErrors.value = error.response.data.errors;

          swal({
            icon: "error",
            title: "Server error, please try again.",
          });
        }
      });
  };

  const getCategory = async (id) => {
    axiosClient.get("/categories/" + id).then((response) => {
      category.value = response.data.data;
    });
  };

  const storeCategory = async (category) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    let serializedCategory = new FormData();
    for (let item in category) {
      if (category.hasOwnProperty(item)) {
        serializedCategory.append(item, category[item]);
      }
    }

    axiosClient
      .post("/categories", serializedCategory)
      .then((response) => {
        router.push({ name: "categories.index" });
        swal({
          icon: "success",
          title: "Category saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const updateCategory = async (category) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    axiosClient
      .put("/categories/" + category.id, category)
      .then((response) => {
        router.push({ name: "categories.index" });
        swal({
          icon: "success",
          title: "Category saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const deleteCategory = async (id) => {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#ef4444",
      timer: 20000,
      timerProgressBar: true,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axiosClient
          .delete("/categories/" + id)
          .then((response) => {
            getCategories();
            router.push({ name: "categories.index" });
            swal({
              icon: "success",
              title: "Category deleted successfully",
            });
          })
          .catch((error) => {
            swal({
              icon: "error",
              title: "Something went wrong",
            });
          });
      }
    });
  };

  return {
    categories,
    category,
    getCategories,
    getCategory,
    storeCategory,
    validationErrors,
    isLoading,
    updateCategory,
    deleteCategory,
  };
}
